var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-box",class:['start-line', {'end-line': _vm.endLine}, {'btn-line': _vm.btnLine}]},[_c('span',{style:({ 'background-color': [_vm.background ? '#f8f8f9' : '#FFFFFF'] })})])}
var staticRenderFns = []

export { render, staticRenderFns }